<template>
  <section class="section page__content">
    <div class="table__buttons">
      <transition name="fade">
        <div class="page__item" v-show="approve.isActiveDeleteControls">
          <AppButtonSmRemove title="Удалить"
                             @click.stop.native="showRemoveConfirmation"
                             :disabled="!this.isCreate && isDisabling"
          />
        </div>
      </transition>
      <AppButtonSmAdd title="Создать"
                      @click.stop.native="openModal(null)"
                      :disabled="!this.isCreate && isDisabling"
      />
    </div>

    <div class="page__table" v-if="controls.length > 0">
      <AppTable :data="controls"
                :headers="approve.tableControlsHeader.headers"
                :has-checkbox="!this.isCreate && !isDisabling"
                :isMenuControlsActive=false
                :all-items-active="approve.tableControlsHeader.allActive"
                @toggle-active-item="toggleActiveItem"
                @toggle-active-all="toggleActiveAll"
                @edit-this-item="openModal"
                @show-this-item="openModal"
      />
    </div>
    <div class="page__row mb-20"  v-else>
      <div class="no-records">
        <AppNoRecordsPlaceholder text="Записи не найдены"/>
      </div>
    </div>

    <transition name="fade">
      <ApproveUpdateControlModal v-if="approve.modalControl.active && !isDisabling"
                                 :state="approve.modalControl"
                                 :options="userOptions"
                                 :value="approve.modalControl.value"
                                 :valid="validation.control"
                                 @set-item-select="setItemSelect"
                                 @save-item-info="saveItemControl"
                                 @clear-validation="clearValidation"
                                 @close-modal="closeModal"
      />

      <AppConfirmation v-if="removeConfirmationControls.active  && !isDisabling"
                       text="Вы действительно хотите убрать этих пользователей?"
                       @confirm="deleteSelectedControls()"
                       @reject="closeModalRemoveSelectedControls"
      />

      <AppModal v-if="deleteControlsResponse.isActive && !isDisabling"
                :title="deleteControlsResponse.title"
                :text="deleteControlsResponse.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteControlsResponse.type"
                @confirm="deleteControlsResponseClose"
      />
    </transition>

    </section>

</template>

<script>
import ApproveUpdateControlModal from '@/components/approve/ApproveUpdateControlModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppModal from '@/components/page/modal/AppModal'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
export default {
  name: 'ApproveUpdateControls',
  components: {
    AppConfirmation,
    AppModal,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    AppButtonSmRemove,
    ApproveUpdateControlModal
  },
  data () {
    return {
      removeConfirmationControls: {
        active: false,
        id: null,
        group: false
      },
      deleteControlsResponse: {
        isActive: false,
        title: 'Успех!',
        text: 'Вы успешно убрали пользователя(ей)',
        type: 'main'
      },
      isCreate: false
    }
  },
  computed: {
    approve () {
      return this.$store.getters['approve/details/[approve] getItemForUpdate']
    },
    userOptions () {
      return this.$store.getters['approve/details/[approve] getItemUpdateControlsOptions']
    },
    validation () {
      return this.$store.getters['approve/details/[approve] getItemUpdateValidation']
    },
    controls () {
      return this.$store.getters['approve/details/[approve] getItemUpdateControls'].map(control => {
        return {
          id: control.id,
          isActive: control.isActive,
          values: [
            control.value.name
          ]
        }
      })
    },
    isDisabling () {
      return this.$store.getters['approve/details/[approve] getItemUpdateIsDisabling']
    }
  },
  methods: {
    openModal (value) {
      return this.$store.commit('approve/details/[approve] OPEN_ITEM_UPDATE_CONTROL_MODAL', value)
    },
    setItemSelect (value) {
      return this.$store.commit('approve/details/[approve] SET_ITEM_UPDATE_CONTROL_VALUE', value)
    },
    clearValidation (value) {
      return this.$store.commit('approve/details/[approve] CLEAR_ITEM_UPDATE_VALIDATION', value)
    },
    saveItemControl () {
      return this.$store.commit('approve/details/[approve] SAVE_ITEM_UPDATE_CONTROL')
    },
    closeModal () {
      return this.$store.commit('approve/details/[approve] CLOSE_ITEM_UPDATE_CONTROL_MODAL')
    },
    toggleActiveItem (value) {
      return this.$store.commit('approve/details/[approve] TOGGLE_ITEM_UPDATE_CONTROL_ACTIVE_ITEM', value)
    },
    toggleActiveAll () {
      return this.$store.commit('approve/details/[approve] TOGGLE_ITEM_UPDATE_CONTROL_ACTIVE_ALL')
    },
    showRemoveConfirmation () {
      this.removeConfirmationControls.active = true
    },
    closeModalRemoveSelectedControls () {
      this.removeConfirmationControls.active = false
    },
    deleteSelectedControls () {
      this.$store.commit('approve/details/[approve] DELETE_ITEM_UPDATE_CONTROL')
      this.removeConfirmationControls.active = false
      this.deleteControlsResponse.isActive = true
    },
    deleteControlsResponseClose () {
      this.deleteControlsResponse.isActive = false
    }
  },
  mounted () {
    const id = this.$router.history.current.params.id
    if (id === 'create') {
      this.isCreate = true
    }
  }
}
</script>

<style scoped>
.no-records {
  margin-top: 40px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
